import { Component, type ReactNode } from 'react';
import { tr } from '../lib/i18n.ts';

export function AppFallback() {
  return (
    <div className="app-state" role="status">
      <span className="spinner" aria-hidden />
      <span className="visually-hidden">{tr.common.loading}</span>
    </div>
  );
}

/** Lazy app chunks that failed to download; React caches the rejected import, so only a reload recovers. */
function isChunkLoadError(error: unknown) {
  return error instanceof Error && /dynamically imported module|Importing a module script failed|error loading dynamically/i.test(error.message);
}

export class AppBoundary extends Component<{ children: ReactNode }, { failed: boolean; chunk: boolean }> {
  override state = { failed: false, chunk: false };

  static getDerivedStateFromError(error: unknown) {
    return { failed: true, chunk: isChunkLoadError(error) };
  }

  override componentDidCatch(error: unknown) {
    console.error('App crashed', error);
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="app-state" role="alert">
        <p>{tr.common.unknownError}</p>
        <button type="button" className="btn" onClick={() => (this.state.chunk ? window.location.reload() : this.setState({ failed: false, chunk: false }))}>
          {tr.common.retry}
        </button>
      </div>
    );
  }
}
